import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Input from './input.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var baseStyle = _objectSpread(_objectSpread({}, Input.baseStyle.field), {}, {
  minHeight: '80px',
  lineHeight: 'short',
  verticalAlign: 'top'
});
var variants = {
  "default": function _default(props) {
    return Input.variants["default"](props).field;
  },
  floating: function floating(props) {
    return Input.variants.floating(props).field;
  }
};
var sizes = {
  xs: _objectSpread(_objectSpread({}, Input.sizes.xs.field), {}, {
    py: Input.sizes.xs.field.px
  }),
  sm: _objectSpread(_objectSpread({}, Input.sizes.sm.field), {}, {
    py: Input.sizes.sm.field.px
  }),
  md: _objectSpread(_objectSpread({}, Input.sizes.md.field), {}, {
    py: Input.sizes.md.field.px
  }),
  lg: _objectSpread(_objectSpread({}, Input.sizes.lg.field), {}, {
    py: Input.sizes.lg.field.px
  })
};
var defaultProps = {
  size: 'md',
  variant: 'default'
};
var Textarea = {
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: defaultProps
};
export { Textarea as default };